import React, {useEffect, useState, useRef, useContext} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {useAuth} from '../context/AuthContext';
import Home from "../components/Home/Home";
import loadingImg from '../static_files/LoadingRobot.svg';
import '../App.css';
import gsap from 'gsap';
import {SwapMainAppContext} from "../context/SwapMainAppContext";

const GatewayVerifier = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const {verifyGatewayToken} = useAuth();
    const [loading, setLoading] = useState(false);
    const [isEmailLogin, setIsEmailLogin] = useState(false);
    const loadingRef = useRef(null);
    const {
        setGatewayToken
    } = useContext(SwapMainAppContext);
    useEffect(() => {
        const checkAndVerifyToken = async () => {
            const queryParams = new URLSearchParams(location.search);
            const emailToken = queryParams.get('token');
            if (emailToken) {
                setGatewayToken(emailToken)
            }
            // Check if this is an email login attempt
            if (location.pathname === '/email' && emailToken) {
                setIsEmailLogin(true);
                setLoading(true);

                try {
                    // Verify the email token
                    const isValid = await verifyGatewayToken(emailToken);
                    if (!isValid) {
                        // Clear all stored data if token is invalid
                        localStorage.removeItem("userEmail");
                        localStorage.removeItem("emailUserWalletAddress");
                        localStorage.removeItem("gatewayToken");
                        localStorage.setItem("emailLogin", 'false');
                        localStorage.removeItem("emailUserSelectedChain");
                        localStorage.removeItem("isWhitelist");

                        // Redirect to home without token
                        navigate('/', {replace: true});
                    } else {

                        // Token is valid, store it
                        localStorage.setItem('gatewayToken', emailToken);
                        // console.log('2', emailToken)
                        setGatewayToken(emailToken)
                        localStorage.setItem('emailLogin', 'true');
                        // await fetchUserInfoAfterConnect()
                        // Redirect to home, which will now show authenticated state
                        navigate('/', {replace: true});
                    }
                } catch (error) {
                    console.error('Error verifying token:', error);
                    navigate('/', {replace: true});
                } finally {
                    setLoading(false);
                }
                return;
            }

            // Check if user has a stored token from previous email login
            const storedToken = localStorage.getItem('gatewayToken');
            if (storedToken) {
                setIsEmailLogin(true);
            }
        };

        checkAndVerifyToken();
    }, [location, navigate, verifyGatewayToken]);

    // GSAP animation for the loading image
    useEffect(() => {
        if (loading && loadingRef.current) {
            // Reset position
            gsap.set(loadingRef.current, {x: -200, opacity: 0});

            // Create animation timeline
            const tl = gsap.timeline({repeat: -1});

            // Animate from left to right
            tl.to(loadingRef.current, {
                x: window.innerWidth + 100, // Move past the right edge
                opacity: 1,
                duration: 4,
                ease: "power1.inOut"
            });
        }
    }, [loading]);

    // Show loading screen only during email token verification
    if (loading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'center',
                height: '100vh',
                overflow: 'hidden', // Prevent scrollbars during animation
                position: 'relative'
            }}>
                <img
                    ref={loadingRef}
                    // className="LoadingImage"
                    src={loadingImg}
                    alt="Loading"
                    style={{
                        position: 'absolute' // Allow positioning for animation
                    }}
                />
            </div>
        );
    }

    // Render Home component with email login state
    return <Home isEmailAuthenticated={isEmailLogin}/>;
};

export default GatewayVerifier;